import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Paragraph, Text } from '../../../../elements/typography'
import { media } from '../../../../style/media'
import Button from '../PlayerControls/Button'

const Modal = styled(View)`
  position: absolute;
  z-index: ${(props) => props.theme.zIndex.modals};
  right: ${(props) => props.theme.spacing.sm * 1.5 + props.rightOffset}px;
  ${(props) => props.dropUp && 'bottom: 100px'};
  min-width: ${(props) => props.theme.spacing.large * 3}px;
  ${media.sm`
    min-width: ${(props) => props.theme.spacing.large * 4.5}px;
  `}
  ${media.lg`
    min-width: ${(props) => props.theme.spacing.large * 5}px;
  `}
`

const TitleWrapper = styled(View)`
  background: ${(props) => props.theme.colors.grayDarker};
  padding: ${(props) => props.theme.spacing.sm}px;
`

const Title = styled(Paragraph)`
  margin: 0;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  text-align: center;
`

const Option = styled(Button)`
  background: ${(props) => props.theme.colors[props.selected ? 'primary' : 'background']};
  padding: ${(props) => props.theme.spacing.sm}px;
  align-items: flex-end;
`

const OptionText = styled(Text).attrs({
  numberOfLines: 1,
})`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.small}px;
  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.medium}px;
  `}
  ${media.lg`
    font-size: ${(props) => props.theme.fontSizes.larger}px;
  `}
`

export const SelectionModal = ({
  options,
  activeIndex = -1,
  onOptionIndexChosen,
  onRequestClose,
  rightOffset = 0,
  dropUp,
  defaultOptionMsg,
  titleMsg,
}) => {
  const onIndexChosen = (index) => {
    onOptionIndexChosen(index)
    onRequestClose && onRequestClose()
  }
  return (
    <Modal dropUp={dropUp} rightOffset={rightOffset}>
      {titleMsg && (
        <TitleWrapper>
          <Title>
            <FormattedMessage {...titleMsg} />
          </Title>
        </TitleWrapper>
      )}
      {options.map(({ label }, index) => (
        <Option
          key={label}
          selected={index === activeIndex}
          onPress={() => onIndexChosen(index)}
          activeOpacity={0.8}
        >
          <OptionText>{label}</OptionText>
        </Option>
      ))}

      {defaultOptionMsg && (
        <Option selected={activeIndex === -1} onPress={() => onIndexChosen(-1)} activeOpacity={0.8}>
          <OptionText>
            <FormattedMessage {...defaultOptionMsg} />
          </OptionText>
        </Option>
      )}
    </Modal>
  )
}

SelectionModal.propTypes = {
  /** List of options options */
  options: PropTypes.array.isRequired,
  /** The index of the active option */
  activeIndex: PropTypes.number.isRequired,
  /** Function to update active subtitles track */
  onOptionIndexChosen: PropTypes.func.isRequired,
  /** When present the controls menu is closed automatically after making a selection */
  onRequestClose: PropTypes.func,
  /** Additional right offset to the modal position */
  rightOffset: PropTypes.number,
  /** Open the modal above the button rather than below it */
  dropUp: PropTypes.bool,
  /** An additional option to display last, indicating no selection */
  defaultOptionMsg: PropTypes.object,
}
